import type { CategorieDocument, DocumentLakou, TypePieceAffichee } from './types.js';

/**
 * Catégories des actes notariés déjà obtenus (#33), distincts des pièces envoyées par les familles.
 * Donnée versionnée : la liste évolue avec la décision d'Isabelle, sans changer le code (RFC-L58-01 : catégorie dédiée).
 */
export const CATEGORIES_ACTES_NOTARIES: { version: string; valeurs: readonly CategorieDocument[] } = {
  version: '2026-10-17',
  valeurs: ['titre', 'retour_notaire'],
};

export function typeDePiece(mime: string): TypePieceAffichee {
  if (mime.startsWith('image/')) return 'photo';
  if (mime.startsWith('video/')) return 'video';
  if (mime === 'application/pdf') return 'pdf';
  return 'autre';
}

export function separerDepots(documents: readonly DocumentLakou[]): { actesNotaries: DocumentLakou[]; piecesFamilles: DocumentLakou[] } {
  const acte = (d: DocumentLakou): boolean => CATEGORIES_ACTES_NOTARIES.valeurs.includes(d.category);
  return { actesNotaries: documents.filter(acte), piecesFamilles: documents.filter((d) => !acte(d)) };
}

/** Toutes les vidéos du dossier (#54), sans plafond, de la plus ancienne à la plus récente. */
export const videosDuDossier = (documents: readonly DocumentLakou[]): DocumentLakou[] =>
  documents
    .filter((d) => typeDePiece(d.currentVersion.mime) === 'video')
    .sort((a, b) => Date.parse(a.receivedAt) - Date.parse(b.receivedAt));

export interface FicheTitre {
  type: 'pdf';
  src: string;
  titre: string;
  totalPages?: number;
}

/** Fiche titre (#34) : le PDF du titre de propriété, consultable page à page. */
export function ficheTitre(document: DocumentLakou, urlContenu: (d: DocumentLakou) => string): FicheTitre | null {
  if (document.category !== 'titre' || typeDePiece(document.currentVersion.mime) !== 'pdf') return null;
  const pages = document.currentVersion.preview.pages;
  return { type: 'pdf', src: urlContenu(document), titre: document.title, ...(pages === null ? {} : { totalPages: pages }) };
}
